import { api } from './configs/axiosConfig';

const endPoint = "/table-orders";

export const tableOrderAPI = {
    saveTableOrder: async function (tableOrderNo, tableOrderDate, tableNo, subTableNo, roomNo, items, grandTotal, discRate, scRate, tdlRate,
                                    nbtRate, vatRate, netTotal, isNewOrder, cusCode, cusName, occupyNo, pax, remarks, locCode,fromPCode) {
        const reponse = await api.request({
            url: endPoint,
            method: 'POST',
            data: {
                tableOrderNo, tableOrderDate, tableNo, subTableNo, roomNo, items, grandTotal, discRate, scRate, tdlRate, nbtRate, vatRate,
                netTotal, isNewOrder, cusCode, cusName, occupyNo, pax, remarks, locCode, fromPCode
            }
        });

        return reponse.data;
    },
    getTableOrder: async function (tableNo, subTableNo,roomNo, locCode) {
        const reponse = await api.request({
            url: `${endPoint}/table-order`,
            method: 'GET',
            params: { tableNo, subTableNo, roomNo, locCode }
        });

        return reponse.data;
    },
    getNextTabelOrderNo: async function () {
        const reponse = await api.request({
            url: `${endPoint}/next-tableorder`,
            method: 'GET'
        });

        return reponse.data;
    },
    voidTableOrderItem: async function (tableOrderNo, itemCode, itemDesc, qty, price, reason, kotbotno) {
        const reponse = await api.request({
            url: `${endPoint}/item-void`,
            method: 'POST',
            data: { tableOrderNo, itemCode, itemDesc, qty, price, reason, kotbotno }
        });

        return reponse.data;
    }
}